function log(file, message) {
  const loggingEnabled = true

  if (loggingEnabled) {
    console.log('[' + file + '] - ' + message)
  }
}

export default log
